import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../shared';

import { CanalVendaLogoBadgeComponent } from './canal-venda-logo-badge.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        CanalVendaLogoBadgeComponent
    ],
    exports: [
        CanalVendaLogoBadgeComponent
    ]
})
export class CanalVendaLogoBadgeModule { }
